import UserGroups from './UserGroups'
import enhance from './UserGroups.enhancer'

export default enhance(UserGroups)

export const userGroupColumns = [
  {
    width: '100%',
    field: 'name',
    label: 'Group Name'
  },
  {
    width: 200,
    field: 'trapCount',
    label: 'Traps'
  },
  {
    width: 200,
    format: 'timeDate',
    field: 'lastSynced',
    label: 'Data last collected',
    helpText: 'Last time the groups traps were synced through the app'
  },
  {
    width: 200, 
    field: 'select', 
    selectable: true,
    align: 'flex-end',
    format: 'expandBox',
    selectableLabel: 'Remove access'
  }
]



// WEBPACK FOOTER //
// ./src/components/organisms/UserGroups/index.js